import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sliderApi } from "../api/sliderApi";

export default function SliderCreate() {
  const nav = useNavigate();

  const [titleAz, setTitleAz] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleRu, setTitleRu] = useState("");

  const [descAz, setDescAz] = useState("");
  const [descEn, setDescEn] = useState("");
  const [descRu, setDescRu] = useState("");

  const [imageFile, setImageFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await sliderApi.create({
        titleAz, titleEn, titleRu,
        descAz, descEn, descRu,
        imageFile
      });
      nav("/sliders");
    } catch (err) {
      alert(err?.response?.data || err.message || "Create failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="pageTitle">Slider yarat</h1>

      <div className="card">
        <div className="cardHead">
          <span className="badge">multipart/form-data</span>
        </div>

        <div className="cardBody">
          <form className="form" onSubmit={submit}>
            <div>
              <span className="label">Başlıq (AZ) *</span>
              <input className="input" value={titleAz} onChange={(e) => setTitleAz(e.target.value)} required />
            </div>

            <div>
              <span className="label">Başlıq (EN)</span>
              <input className="input" value={titleEn} onChange={(e) => setTitleEn(e.target.value)} />
            </div>

            <div>
              <span className="label">Başlıq (RU)</span>
              <input className="input" value={titleRu} onChange={(e) => setTitleRu(e.target.value)} />
            </div>

            <div>
              <span className="label">Məzmun (AZ)</span>
              <textarea className="textarea" rows={4} value={descAz} onChange={(e) => setDescAz(e.target.value)} />
            </div>

            <div>
              <span className="label">Məzmun (EN)</span>
              <textarea className="textarea" rows={4} value={descEn} onChange={(e) => setDescEn(e.target.value)} />
            </div>

            <div>
              <span className="label">Məzmun (RU)</span>
              <textarea className="textarea" rows={4} value={descRu} onChange={(e) => setDescRu(e.target.value)} />
            </div>


            <div>
              <span className="label">Şəkil</span>
              <input type="file" accept="image/*" onChange={(e) => setImageFile(e.target.files?.[0] || null)} />
            </div>

            <div className="btnRow">
              <button className="btn btnPrimary" disabled={saving}>
                {saving ? "Saving..." : "Yadda saxla"}
              </button>
              <button type="button" className="btn" onClick={() => nav("/sliders")}>
                Ləğv et
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
